import { Component, computed, input } from '@angular/core';
import { DetailViewDto } from '@myarvato/modules/transport/models';
import { DetailsSidebarQuickselectComponent } from '../details-sidebar-quickselect/details-sidebar-quickselect.component';
import { DetailsSidebarReferencesComponent } from '../details-sidebar-references/details-sidebar-references.component';

@Component({
  selector: 'transport-detail-sidebar',
  imports: [DetailsSidebarQuickselectComponent, DetailsSidebarReferencesComponent],
  templateUrl: './details-sidebar.component.html',
  styleUrl: './details-sidebar.component.scss',
})
export class DetailsSidebarComponent {
  public readonly details = input.required<DetailViewDto>();

  protected readonly renderQuickselect = computed(() => {
    const packageCount = this.details()?.packages?.length ?? 0;
    return packageCount > 1;
  });
}
